var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWorkingDocumentIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-dc-tpl": 3613,
    viewBox: "0 0 140 175",
    width: "100%",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "One combined working document",
    style: {
      display: "block",
      maxWidth: 152,
      height: "auto"
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-dc-tpl": 3614,
    x: 0.5,
    y: 0.5,
    width: 139,
    height: 174,
    rx: 7.5,
    fill: "#fff",
    stroke: "#E6E6E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    "data-dc-tpl": 3615,
    x: 12,
    y: 13.5,
    width: 37,
    height: 5,
    rx: 2.5,
    fill: "#8B6CF9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    "data-dc-tpl": 3616,
    x: 12,
    y: 26.5,
    width: 116,
    height: 5,
    rx: 2.5,
    fill: "#ECE7FE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    "data-dc-tpl": 3617,
    x: 12,
    y: 39.5,
    width: 116,
    height: 5,
    rx: 2.5,
    fill: "#ECE7FE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    "data-dc-tpl": 3618,
    x: 12,
    y: 52.5,
    width: 37,
    height: 5,
    rx: 2.5,
    fill: "#8B6CF9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    "data-dc-tpl": 3619,
    x: 12,
    y: 65.5,
    width: 116,
    height: 5,
    rx: 2.5,
    fill: "#ECE7FE"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    "data-dc-tpl": 3620,
    x: 12,
    y: 78.5,
    width: 116,
    height: 5,
    rx: 2.5,
    fill: "#ECE7FE"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    "data-dc-tpl": 3621,
    x: 12,
    y: 91.5,
    width: 37,
    height: 5,
    rx: 2.5,
    fill: "#8B6CF9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    "data-dc-tpl": 3622,
    x: 12,
    y: 104.5,
    width: 116,
    height: 5,
    rx: 2.5,
    fill: "#ECE7FE"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    "data-dc-tpl": 3623,
    x: 12,
    y: 117.5,
    width: 5,
    height: 5,
    rx: 2.5,
    fill: "#8B6CF9"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    "data-dc-tpl": 3624,
    x: 21,
    y: 117.5,
    width: 107,
    height: 5,
    rx: 2.5,
    fill: "#ECE7FE"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    "data-dc-tpl": 3625,
    x: 12,
    y: 130.5,
    width: 5,
    height: 5,
    rx: 2.5,
    fill: "#8B6CF9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    "data-dc-tpl": 3626,
    x: 21,
    y: 130.5,
    width: 107,
    height: 5,
    rx: 2.5,
    fill: "#ECE7FE"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    "data-dc-tpl": 3627,
    x: 12,
    y: 143.5,
    width: 5,
    height: 5,
    rx: 2.5,
    fill: "#8B6CF9"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    "data-dc-tpl": 3628,
    x: 21,
    y: 143.5,
    width: 107,
    height: 5,
    rx: 2.5,
    fill: "#ECE7FE"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    "data-dc-tpl": 3629,
    x: 12,
    y: 156.5,
    width: 116,
    height: 5,
    rx: 2.5,
    fill: "#ECE7FE"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWorkingDocumentIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/WorkingDocumentIcon.c122e40e9a1bc264de57d0993ca127b4.svg";